var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceDialog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 115,
    viewBox: "0 0 624 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 624,
    height: 115,
    rx: 20,
    fill: "#FCEFEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 18,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF8B61"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 385.872,
    y: 25,
    width: 24.5494,
    height: 63.8285,
    rx: 12.2747,
    fill: "#5B34E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 361.936,
    y: 49.5493,
    width: 23.9357,
    height: 39.279,
    rx: 11.9678,
    fill: "#7961FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 64.2788,
    width: 23.9357,
    height: 24.5494,
    rx: 11.9678,
    fill: "#E0CAC2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 42,
    width: 82,
    height: 24,
    rx: 12,
    fill: "#E0CAC2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_81819)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.069,
    y: 65.2622,
    width: 88,
    height: 24,
    rx: 12,
    fill: "#3C2478"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.069,
    y: 65.2622,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#7161FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484 57C484 73.0163 471.016 86 455 86C438.984 86 426 73.0163 426 57C426 40.9837 438.984 28 455 28C471.016 28 484 40.9837 484 57ZM440.946 57C440.946 64.7619 447.238 71.0542 455 71.0542C462.762 71.0542 469.054 64.7619 469.054 57C469.054 49.2381 462.762 42.9458 455 42.9458C447.238 42.9458 440.946 49.2381 440.946 57Z",
    fill: "#E0CAC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468.043 74.1259C470.544 77.4093 475.332 78.0862 477.87 74.8314C479.128 73.2186 480.215 71.472 481.111 69.6181C483.096 65.5106 484.084 60.9927 483.994 56.4316C483.905 51.8705 482.741 47.3948 480.596 43.3682C478.452 39.3416 475.388 35.8778 471.653 33.2581C467.918 30.6384 463.618 28.9368 459.102 28.2916C454.586 27.6463 449.981 28.0756 445.662 29.5445C441.343 31.0135 437.431 33.4807 434.245 36.7456C432.807 38.2192 431.535 39.8365 430.447 41.5679C428.251 45.0622 430.518 49.3344 434.456 50.5676L435.287 50.8278C438.767 51.9173 442.395 49.7937 444.942 47.1841C446.486 45.6019 448.381 44.4062 450.475 43.6943C452.568 42.9824 454.799 42.7743 456.988 43.0871C459.177 43.3998 461.261 44.2244 463.071 45.494C464.881 46.7636 466.366 48.4422 467.405 50.3936C468.444 52.345 469.008 54.5141 469.052 56.7245C469.095 58.935 468.616 61.1245 467.654 63.1151C466.068 66.3981 465.306 70.5324 467.515 73.4331L468.043 74.1259Z",
    fill: "#5B34E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_81819"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.069,
    y: 65.2622,
    width: 88,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceDialog);
export default __webpack_public_path__ + "static/media/experience-dialog.6c684e6fe32e6250fd4ea0affe555a75.svg";
export { ForwardRef as ReactComponent };